var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.data && _vm.data.length
    ? _c("div", { staticClass: "activity-timeline side-hs-activity" }, [
        _c(
          "div",
          { staticStyle: { position: "relative" } },
          [
            _c("TitleBlock", {
              attrs: {
                text: "Activity Timeline",
                size: "small",
                color: "corporateblue",
                type: "alternative",
              },
            }),
            _vm._v(" "),
            _c("Tip", {
              staticClass: "tip-button-act",
              attrs: {
                "tip-content":
                  "A series of updates laying out the legislative process of a new bill/law, including the consultation process if relevant, in date order.",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "activity-timeline-list" },
          _vm._l(_vm.data, function (item) {
            return _c(
              "div",
              {
                key: item.nid,
                staticClass: "timeline-item",
                class: {
                  "informative-update": item.classification === "Informative",
                  "indicative-update": item.classification === "Indicative",
                  "actionable-update": item.classification === "Actionable",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "timeline-item__date" },
                  [
                    _vm._v("\n        Release date "),
                    _c("Date", { attrs: { text: item.releaseDate } }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "timeline-item__name" }, [
                  _c("a", { attrs: { href: item.url } }, [
                    _vm._v(_vm._s(item.title)),
                  ]),
                ]),
              ]
            )
          }),
          0
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }